// extracted by mini-css-extract-plugin
export var dropdownButton = "_21-0";
export var fullWidthDropdownButton = "_21-1";
export var icon = "_21-3";
export var iconPlaceholder = "_21-2";
export var menuItemRow = "_21-8";
export var separator = "_21-c";
export var shortcutContainer = "_21-7";
export var shortcutIconLg = "_21-6";
export var shortcutIconMd = "_21-5";
export var shortcutIconSm = "_21-4";
export var submenuChevron = "_21-b";
export var submenuDropdown = "_21-9";
export var submenuTriggerRow = "_21-a";